import GuardrailDetail from './GuardrailDetail';

export default GuardrailDetail;
